<template>
  <AppDialog
    :title="dialogTitle"
    :show="show"
    position="top"
    size="large"
    class="getting-started-unusual-activity-member-dialog"
    append-to-body
    @close="closeDialog"
  >
    <slot name="titleLabel">
      <div class="member-details">
        <AppAvatar
          :avatar="member.avatar"
          class="avatar"
          size="speck"
        />
        <div class="name">
          {{ member.name }}
        </div>
        <div class="divider"></div>
        <div class="instances">
          {{ member.instances.length }} {{ $filters.pluralize(member.instances.length, 'instance', 'instances') }}
        </div>
      </div>
    </slot>

    <div class="content">
      <div class="instance-list">
        <div
          v-for="instance in member.instances"
          :key="instance.id"
        >
          <div
            class="instance"
            :class="{ selected: selectedInstance.id === instance.id }"
            @click="toggleSelectedInstance(instance)"
          >
            <div class="information">
              <div class="title">{{ instance.title }}</div>
              <div class="time">{{ instance.timespan }} ({{ instance.duration }})</div>
            </div>

            <div
              class="unusual-activity-confidence-label"
              :class="instance.confidence.toLocaleLowerCase()"
            >
              {{ instance.confidence }}
            </div>
          </div>
        </div>
      </div>
      <div class="details">
        <div class="title">
          {{ selectedInstance.title }}
        </div>

        <div class="description">
          {{ selectedInstance.description }}
        </div>

        <div class="time-details">
          <div class="date">
            <div class="label-text">Date & time</div>
            <div>{{ selectedInstance.date }}</div>
            <div>{{ selectedInstance.timespan }} {{ selectedInstance.time_zone }}</div>
          </div>
          <div class="duration">
            <div class="label-text">Duration</div>
            <div>{{ selectedInstance.human_duration }}</div>
          </div>
        </div>

        <div class="activity">
          <div class="overall">
            <div class="label-text">Overall activity</div>
            <div class="value">{{ selectedInstance.overall_activity }}</div>
          </div>

          <div class="breakdown">
            <div class="label-text">Activity breakdown</div>
            <div class="mouse">
              <div
                class="progress-bar green"
                :style="{ width: selectedInstance.activity_breakdown.mouse }"
              ></div>
              <div class="percentage">
                <div class="legend green"></div>
                <div>{{ selectedInstance.activity_breakdown.mouse }} - Mouse</div>
              </div>
            </div>

            <div class="keyboard">
              <div
                class="progress-bar orange"
                :style="{ width: selectedInstance.activity_breakdown.keyboard }"
              ></div>
              <div class="percentage">
                <div class="legend orange"></div>
                <div>{{ selectedInstance.activity_breakdown.keyboard }} - Keyboard</div>
              </div>
            </div>
          </div>
        </div>

        <div class="top-apps">
          <div class="label-text">Top apps in use</div>
          <div class="apps">
            <div
              v-for="(app, index) in selectedInstance.top_apps"
              :key="index"
              class="app"
            >
              <div>{{ app }}</div>
            </div>
          </div>
        </div>

        <div class="top-urls">
          <div class="label-text">Top urls visited</div>
          <div class="urls">
            <div
              v-for="(url, index) in selectedInstance.top_urls"
              :key="index"
              class="url"
              :class="url.class"
            >
              <div>{{ url.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppDialog>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';

export default {
  name: 'MemberUnusualActivityDialog',
  components: {},
  mixins: [GettingStartedMixin],
  props: {
    member: {
      type: Object,
      required: true,
      validator: (value) => {
        const keys = Object.keys(value);

        return keys.includes('name') && keys.includes('instances');
      },
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedInstance: null,
  }),
  computed: {
    dialogTitle() {
      const possessiveName = this.member.name.endsWith('s') ? `${this.member.name}'` : `${this.member.name}'s`;

      return `${possessiveName} unusual instances`;
    },
  },
  beforeMount() {
    this.selectedInstance = this.member.instances[0];
  },
  methods: {
    openViewDialog(memberId) {
      this.selectedMemberId = memberId;
      this.showMemberDialog = true;
    },
    closeDialog() {
      this.$emit('close');
    },
    toggleSelectedInstance(instance) {
      this.selectedInstance = instance;
    },
  },
};
</script>
